import { useRouter } from 'next/router';

import SigninLayout from '../../components/scenes/SigninScene/SigninLayout';

const SignInWithOrg = () => {
  const router = useRouter();
  return (
    <SigninLayout
      organization_slug={router.query.slug as string}
      redirect={router.query.redirect as string}
    />
  );
};

SignInWithOrg.configs = {
  title: 'Sign in',
  desc: 'Create or login with your Hookdeck account',
};

export default SignInWithOrg;
